module.exports = __webpack_public_path__ + "img/version-colores-corporativos-caluga-municipalidad.70a13be0.svg";